/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecureScoreDerivedDetails {
    getFixupPrototypeFunction() { return SecureScoreDerivedDetails.fixupPrototype; }

    static newInstance(model: Partial<SecureScoreDerivedDetails>): SecureScoreDerivedDetails {
        let obj = Object.assign(new SecureScoreDerivedDetails(), model);
        SecureScoreDerivedDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecureScoreDerivedDetails>): SecureScoreDerivedDetails {
        if (!model) return null;
        return SecureScoreDerivedDetails.newInstance(<SecureScoreDerivedDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecureScoreDerivedDetails) {
        if (!obj) return;

        models.SecureScoreDerivedDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecureScoreDerivedDetails): boolean {
        Object.setPrototypeOf(obj, SecureScoreDerivedDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.healthy_resource_count === undefined) {
            this.healthy_resource_count = 0;
        }
        if (this.unhealthy_resource_count === undefined) {
            this.unhealthy_resource_count = 0;
        }
        if (this.non_applicable_resource_count === undefined) {
            this.non_applicable_resource_count = 0;
        }
        if (this.weight === undefined) {
            this.weight = 0;
        }
        if (this.score) {
            models.SecureScore.fixupPrototype(this.score);
        }
    }

    /**
     * Display name of policy which allow space this is to mostly show on the ui
     */
    display_name: string;

    /**
     * Number of healthy resources in the control
     */
    healthy_resource_count: number;

    /**
     * Number of unhealthy resources in the control
     */
    unhealthy_resource_count: number;

    /**
     * Number of not applicable resources in the control
     */
    non_applicable_resource_count: number;

    /**
     * Secure score for the tenant
     */
    score: models.SecureScore;

    /**
     * Secure score for the tenant
     */
    weight: number;

}
